import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { round } from '../../utils/NumberUtil'
import { Grid, LinearProgress, Tooltip } from '@mui/material'
import { isNil } from 'lodash'

const ProgressBar = ({
    indeterminate = false,
    progress = 0,
    withMessage = false,
    message = i18n.progressLoading,
    tooltip,
    ...otherProps
}) => {
    const progressComponent = (
        <Grid container justifyContent='center' {...otherProps}>
            {withMessage && (
                <Grid size='auto'>
                    <h6>{message}{indeterminate ? '' : ` (${round(progress, 0)} %)`}</h6>
                </Grid>
            )}
            <Grid size={12}>
                <LinearProgress variant={indeterminate ? 'indeterminate' : 'determinate'} value={progress} data-cy='progress-bar' />
            </Grid>
        </Grid>
    )
    if (isNil(tooltip)) return progressComponent

    return (
        <Tooltip title={tooltip}>
            {progressComponent}
        </Tooltip>
    )
}

ProgressBar.propTypes = {
    indeterminate: PropTypes.bool,
    progress: PropTypes.number,
    withMessage: PropTypes.bool,
    message: PropTypes.string,
    tooltip: PropTypes.string,
    otherProps: PropTypes.shape({}),
}

export default ProgressBar